<template>
    <div>
        <ui-checkbox-input
            v-model="localSelected"
            class="custom-control custom-checkbox stores-list-checkbox"
            :name="`${checkboxName}`"
            @change="checkboxClick"
        />
    </div>
</template>

<script>
import UiCheckboxInput from '../UiCheckboxInput.vue'

export default{
    components: {
        UiCheckboxInput
    },
    props: {
        selectAllItemsDispatchName: {
            type: String,
            default: ''
        },
        unSelectAllItemsDispatchName: {
            type: String,
            default: ''
        },
        areAllItemsSelectedGetterName: {
            type: String,
            default: ''
        },
        checkboxName: {
            type: String,
            default: ''
        },
        checked: {
            type: Boolean,
            default: false
        },
        onChange: {
            type: Function,
            default: () => {}
        }

    },
    computed: {
        amISelected() {
            return this.$store.getters[this.areAllItemsSelectedGetterName]
        }
    },
    watch: {
        amISelected: {
            immediate: true,
            handler(val) {
                if(val === this.localSelected) return
                this.localSelected = val
            }
        },
        checked: {
            immediate: true,
            handler(val) {
                if(val === this.localSelected) return
                this.localSelected = val
            }
        }
    },
    data() {
        return{
            localSelected: false
        }
    },
    methods: {
        checkboxClick() {
            this.onChange(this.localSelected)
        }
    }
}
</script>
